import { notification } from 'antd';

type NotificationType = 'success' | 'info' | 'warning' | 'error';

export const errorHandler = (message?: string, error?: any, notificationType: NotificationType = 'error'): void => {
  const msg = message ?? 'Er is een fout opgetreden';
  let description = msg;
  if (error?.response?.data?.errorDetails) {
    Object.values<any>(error.response.data.errorDetails).forEach(errorDetail => {
      notification[notificationType]({ message: msg, description: errorDetail.message });
    });
    return;
  }

  if (error?.response?.data) {
    description =
      typeof error.response.data === 'object'
        ? (error.response.data.message ??
          error.response.data.messages?.reduce((previous: string, current: string) => (previous.length ? `${previous}. ${current}` : current), ''))
        : error.response.data;
  } else if (typeof error === 'string') {
    description = error;
  }
  notification[notificationType]({ message: msg, description });
};

export const warningHandler = (message?: string, description?: string): void => {
  const msg = message ?? 'warning';
  notification.warning({ message: msg, description: description ?? msg });
};

export const succesHandler = (message?: string, description?: string): void => {
  const msg = message ?? 'succes';
  notification.success({ message: msg, description: description ?? msg });
};
